import { render } from "./PublicBookingNote.vue?vue&type=template&id=5e162abf&scoped=true"
import script from "./PublicBookingNote.vue?vue&type=script&lang=js"
export * from "./PublicBookingNote.vue?vue&type=script&lang=js"

import "./PublicBookingNote.vue?vue&type=style&index=0&id=5e162abf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e162abf"]])

export default __exports__